/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import {
  func, number, string
} from 'prop-types';
import { Fulfillment } from '@thd-olt-component-react/fulfillment';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import Cookies from 'js-cookie';
import { getThdStore, getDeliveryZip } from '../../utils/getLocalizerInfo';
import { addBusinessDays, calculateBusinessDays, convertDate } from '../../utils/dateUtils';
import { useFulfillmentGetData } from '../../../../hooks/useFulfillmentData';

const FulfillmentWrapper = ({ itemId, estimatedDeliveryDate, setIsAddToCartDisabled }) => {

  const [ffmData, setFfmData] = useState({});
  const queryVariables = {
    itemId,
    storeId: getThdStore().storeNumber,
    zipCode: getDeliveryZip(),
  };

  const { data } = useFulfillmentGetData(
    {
      ...queryVariables,
      directData: null,
      quantity: 1,
      bypassQuantitySkip: false
    });

  useEffect(() => {
    if (data?.product) {
      let updatedData = { ...data.product };
      if (updatedData.fulfillment) {
        updatedData.fulfillment = {
          ...updatedData.fulfillment,
          fulfillmentOptions: updatedData.fulfillment.fulfillmentOptions.map((option) => {
            if (option.type === 'delivery') {
              return {
                ...option,
                services: option.services.map((service) => {
                  if (service.deliveryDates) {
                    const leadDays = calculateBusinessDays(new Date(), estimatedDeliveryDate);
                    const updatedDeliveryDates = {
                      ...service.deliveryDates,
                      startDate: convertDate(estimatedDeliveryDate),
                      endDate: convertDate(estimatedDeliveryDate)
                    };
                    return { ...service, deliveryDates: updatedDeliveryDates, leadDays };
                  }
                  return service;
                })
              };
            }
            if (option.type === 'pickup') {
              return {
                ...option,
                services: option.services.map((service) => {
                  if (service.deliveryDates) {
                    const leadDays = calculateBusinessDays(new Date(), estimatedDeliveryDate);
                    const bossStartDate = addBusinessDays(new Date(), leadDays + 2);
                    const bossEndDate = addBusinessDays(bossStartDate,
                      calculateBusinessDays(service.deliveryDates.startDate, service.deliveryDates.endDate));
                    const updatedDeliveryDates = {
                      ...service.deliveryDates,
                      startDate: bossStartDate,
                      endDate: bossEndDate
                    };
                    return { ...service, deliveryDates: updatedDeliveryDates, leadDays };
                  }
                  return service;
                })
              };
            }
            return option;
          })
        };
      }
      setFfmData(
        updatedData
      );
    }
  }, [
    data, estimatedDeliveryDate,
  ]);

  const onFulfillmentChange = ({
    method,
    availableFulfillments,
  }) => {
    if (availableFulfillments.length > 0) {
      setIsAddToCartDisabled(false);
    } else {
      setIsAddToCartDisabled(true);
    }

    let deliveryStartDate = '';
    let deliveryEndDate = '';
    let leadDays = 0;

    if (method === 'ShipToHome') {
      const deliveryOption = ffmData.fulfillment.fulfillmentOptions.find((option) => option.type === 'delivery');
      if (deliveryOption) {
        const service = deliveryOption.services[0];
        if (service && service.deliveryDates) {
          deliveryStartDate = service.deliveryDates.startDate;
          deliveryEndDate = service.deliveryDates.endDate;
          leadDays = service.leadDays;
        }
      }
    } else if (method === 'ShipToStore') {
      const pickupOption = ffmData.fulfillment.fulfillmentOptions.find((option) => option.type === 'pickup');
      if (pickupOption) {
        const service = pickupOption.services[0];
        if (service && service.deliveryDates) {
          deliveryStartDate = service.deliveryDates.startDate;
          deliveryEndDate = service.deliveryDates.endDate;
          leadDays = service.leadDays;
        }
      }
    }
    const now = new Date();
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    Cookies.set(
      `fulfillment-${itemId}`,
      { method, deliveryStartDate, deliveryEndDate, leadDays },
      { expires: endOfDay }
    );
  };
  const fulfillmentProps = {
    itemId,
    covidAlert: true,
    quantity: 1,
    originalConfigId: null,
    dualPath: false,
    directData: ffmData,
    quantityExceeded: false,
    addOnsAssemblyAndMore: null,
    configurableProductDetails: {
      isSpecialOrder: true,
      configuratorHideQuantity: true,
      isConfigurableBlinds: true,
      disableTimer: true
    },
    leadTime: 0,
    hasCustomATC: true,
    disableSTH: false,
    disableBODFS: false,
    disableBOSS: false,
    disablePickupNearBy: true,
    currentSelectedFulfillment: '',
    isTwoTileEnabledFS: true,
    storeId: null,
    deliveryZip: '',
    applianceDirectData: null,
    isBuyBoxLite: false,
    isCartTiles: false,
    localizerStoreDetails: null,
    bopisCutOffBeforeStoreClose: 0,
    cartAction: '',
    lineItemId: '',
    hideShippingThreshold: false,
    onChange: onFulfillmentChange
  };
  return (
    <QueryProvider cacheKey="pip-page-blinds-fulfillment">
      <Fulfillment
        {...fulfillmentProps}
      />
    </QueryProvider>
  );
};
FulfillmentWrapper.propTypes = {
  estimatedDeliveryDate: string,
  itemId: number,
  setIsAddToCartDisabled: func,
};
FulfillmentWrapper.defaultProps = {
  estimatedDeliveryDate: undefined,
  itemId: undefined,
  setIsAddToCartDisabled: () => { },
};
FulfillmentWrapper.dataModel = extend(Fulfillment);

export default FulfillmentWrapper;